import { ACCOUNT_MODAL_TABS } from '../../../../constants';

const initialState = {
  selectedTab: ACCOUNT_MODAL_TABS.signIn,
  temporaryMessage: '',
  email: '',
  signIn: {
    isLoading: false,
    error: {}
  },
  createAccount: {
    isLoading: false,
    error: {}
  },
  forgotPassword: {
    hasResetPassword: false,
    isLoading: false,
    error: {}
  },
  resetPassword: {
    hasResetPassword: false,
    isLoading: false,
    error: {},
    oneUseToken: '',
  }
};

export default initialState;
